export const dealerWiseOsOdReportSubMenu = [{
  path: '/report/dealerWiseOsOdReport/list',
  component: () => import('@/views/report/dealer-wise-os-od-report/list.vue'),
  name: 'report.title',
  meta: {
    title: 'report.dealerWiseOsOdReport.title',
    roles: ['Super Admin', 'Admin', 'Read Only', 'Regional Manager', 'Agent', 'Zonal Manager', 'Payment Manager', 'Account Manager', 'Branch Manager'],
    noCache: true,
    hidden: false,
    icon: 'table'
  }
}];